module.exports = __webpack_public_path__ + "static/media/ecuador.621dbfb1.png";